module.exports = __webpack_public_path__ + "img/db1.628749b7.jpg";